import { Link } from 'react-router-dom';
import { useMemberContext } from './Context/memberContext/MemberContext';
import { removeLocalStorageValue } from './Logout/helpers';
import OneTimeModal from './modals/OneTimeModal';
import { unitPremisesRoute } from '../routes/pages/unit-premises/route';

const localStorageKey = 'members-control-pannel-has-free-trial-unit-premises-message';

export const logoutActions = [
    removeLocalStorageValue(localStorageKey),
];

const HasFreeTrialUnitsAlert = () => {
    const { data } = useMemberContext();

    if (!data.hasFreeTrialUnits) {
        return null;
    }

    return (
        <OneTimeModal
            modalTitle="Action Required: Free Trial Unit Premises"
            localStorageKey={localStorageKey}
            zIndex={19999}
        >
            <p>
                One or more of your unit premises were created during your free trial period and may
                require additional setup. Please take a moment to{' '}
                <Link to={unitPremisesRoute.path}>review your unit premises</Link>{' '}
                and ensure all details are complete.
            </p>
        </OneTimeModal>
    );
};

export default HasFreeTrialUnitsAlert;
